import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/photos/hlthiqLogin.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      setError("Please enter a valid email address");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await fetch('/api/auth/request-password-reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("If an account with this email exists, a password reset link has been sent.");
      } else {
        setError(data.message || "An error occurred while processing your request");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-xl-5">
            <div className="login-card">
              <div className="login-form">
                <div className="text-center mb-4">
                  <img
                    src={logo}
                    alt="HealthIQ Logo"
                    style={{ height: "60px" }}
                    className="mb-3"
                  />
                  <h2
                    className="login-title gradient-text"
                    style={{
                      fontWeight: 700,
                      paddingTop: "0.5rem",
                      background: "linear-gradient(135deg, #4C1788, #8E5BCC)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      color: "transparent"
                    }}
                  >
                    Forgot Password
                  </h2>
                  <p className="text-muted">Enter your email to reset your password</p>
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                {message && (
                  <div className="alert alert-success" role="alert">
                    {message}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                      required
                    />
                  </div>

                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn"
                      disabled={loading}
                      style={{
                        background: "linear-gradient(135deg, #4C1788, #8E5BCC)",
                        border: "none",
                        color: "white",
                        fontWeight: 600,
                      }}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Sending...
                        </>
                      ) : (
                        "Send Reset Link"
                      )}
                    </button>
                  </div>
                </form>

                <div className="text-center mt-4">
                  <Link to="/login" className="text-decoration-none">
                    <small className="text-muted">Back to Login</small>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;